import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe, NgClass, NgStyle } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FileTypes, IFile, IVersion } from '../../interfaces/referral.interface';
import { MatDialog } from '@angular/material/dialog';
import { CollaborationService } from '../../services/collaboration.service';
import { FileDetailsDialogComponent } from '../file-details-dialog/file-details-dialog.component';
import { CreateFileDialogComponent } from '../create-file-dialog/create-file-dialog.component';
import { UserDetailsDialogComponent } from '../user-details-dialog/user-details-dialog.component';
import { assetUrl } from '../../asset-url';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { QuillEditorComponent } from '../../quill/quill-editor.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';

@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrl: './note.component.scss',
    providers: [DatePipe],
    imports: [FormsModule, ReactiveFormsModule, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, NgClass, MatIcon, NgStyle, QuillEditorComponent, SpinnerComponent, DatePipe, AssetUrlPipe]
})
export class NoteComponent implements OnInit, OnDestroy {
  noteName!: FormControl<string | null>;
  control: FormControl = new FormControl('');
  showAttachmentsDrawer: boolean = false;
  draggedOver: boolean = false;
  imageMapper: any = {
    docx: "word_file",
    pptx: "ppt_file",
    xlsx: "excel_file",
    note: "file_document",
    pdf: "pdf",
    zip: "zip",
    eml: "email",
    png: "image_png",
    jpg: "image_png"
  };
  tabs: any;
  currentTab = 'versions';
  fileSaved: boolean = false;
  versionHistory: any;
  currentNote: any;
  note: any;
  attachmentsPayload: any = {
  };
  isEditNote: boolean = false;
  isLoginUserIsCreatorOfNote = true;
  noteActionsList: any = [{
    name: "details",
    displayName: "Details",
    imgUrl: "",
    icon: "info_outline",
    menuItemClasses: "details-icon"
  },
  {
    name: "openLocation",
    displayName: "Open location",
    imgUrl: "link-context",
    menuItemClasses: "icon-mr-1",
  }
  ];

  unsubscribeAction = {
    name: "unsubscribe",
    displayName: "Unsubscribe",
    imgUrl: "bell_cross",
    menuItemClasses: "icon-green"
  };
  showLoader: boolean = false;
  noteUpdatedFromActions: any;
  newNoteCreated: boolean = false;
  initialData = {
    noteName: '',
    content: ''
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<NoteComponent>,
    private datePipe: DatePipe,
    public sanitizer: DomSanitizer,
    public collaborationService: CollaborationService,
    public matDialog: MatDialog,
  ) { }

  ngOnInit() {
    this.noteName = new FormControl('', Validators.required);
    this.initializeNote();
  }

  initializeNote() {
    if (this.data.note) {
      this.note = this.data.note;
      // this.note.draftSaved = false;
      this.isLoginUserIsCreatorOfNote = this.data.loggedUser.id === this.note?.createdBy;
      this.isEditNote = true;
      this.noteName.patchValue(this.note.name);
      let properties = JSON.parse(this.note.properties);
      this.control.patchValue(properties.Body);
      this.initialData = {
        noteName: this.note.name,
        content: properties.Body
      }
      this.tabs = ['versions'];
      this.currentTab = 'versions';
      this.fileSaved = true;
      this.showAttachmentsDrawer = true;
      if (this.note?.versions?.length)
        this.setCurrentViewingVersion(this.note.versions[0]);
      this.initializeNoteActions();
    }
    else {
      this.isEditNote = false;
      this.note = {
        parentId: this.data.parentID,
        appId: this.data.appID,
        spaceId: this.data.spaceID,
        type: 4,
        kind: FileTypes.NOTE,
        // draftSaved: false,
        // isDraft: 0,
        name: null
      };
      this.initializeNoteActions();
    }
  }

  saveNote(type?: string) {
    if (this.noteName.invalid) {
      this.snackBar.open(
        'Name is required.',
        'X',
        {
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["snackbar", "error", "snackbar-top", "error-custom-snack-bar"]
        });
      return;
    }
    this.showAttachmentsDrawer = true;
    if (type) {
      //should store the note in db but should not be visible in table, and when the same user logs in the note should be retained when clicked on create note
      this.snackBar.open(
        'Draft saved at ' + this.datePipe.transform(new Date(), 'h:mm a'),
        'X',
        {
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ["snackbar", "success", "snackbar-top"]
        });

      this.tabs = ['attachments'];
      this.currentTab = 'attachments';
      this.note.draftSaved = true;
      this.note.isDraft = 1;
      // this.updateCommonNoteDetails();
      return;
    }
    else {
      this.tabs = ['versions'];
      this.currentTab = 'versions';
      this.fileSaved = true;
      // this.note.draftSaved = false;
      // this.note.isDraft = 0;
      this.createNote();
    }
  }

  setCurrentViewingVersion(version: IVersion, event?: any) {
    event?.stopPropagation()
    this.currentNote = version;
    let properties = JSON.parse(version.properties);
    this.currentNote.content = properties.Body;
  }

  editNote() {
    this.fileSaved = false;
    this.isEditNote = true;
    this.showAttachmentsDrawer = false;
    // this.tabs = ['attachments'];
    // this.currentTab = 'attachments';
  }

  closeNote(fileDiscarded?: boolean) {
    let noteObj = {
      ...this.note,
      fileName: this.note.name,
      fileExtension: this.note.kind
    };
    this.dialogRef.close(((this.fileSaved && this.control.dirty) || this.noteUpdatedFromActions || this.newNoteCreated) ?
      noteObj : undefined);
  }

  createNote() {
    this.note.name = this.noteName.value;
    this.note.properties = JSON.stringify({
      Body: this.control.value
    });
    this.note.content = this.control.value ?? '';
    this.note.modifiedBy = this.data.loggedUser.id;
    this.note.modifiedAt = new Date();   
    if (this.isEditNote && this.noteName.valid && (this.initialData.content !== this.control.value.trim() || this.initialData.noteName !== this.note.name.trim())) {
      this.collaborationService.updateNote(this.data.spaceID, this.data.appID, {
        contentId: this.note.id,
        parentId: this.data.parentID,
        appId: this.note.appId,
        spaceId: this.note.spaceId,
        name: this.note.name,
        createdAt: this.note.createdAt,
        createdBy: this.note.createdBy,
        modifiedAt: this.note.modifiedAt,
        modifiedBy: this.note.modifiedBy,
        properties: this.note.properties
      })
        .subscribe({
          next: (response: any) => {
            this.note = response;
            this.initialData = {
              noteName: this.note.name,
              content: this.control.value
            }            
            if (response && response.versions && response.versions.length)
              this.setCurrentViewingVersion(response.versions[0]);
            return;
          }, error: (err: any) => {
            this.dialogRef.close('error');
            return;
          }
        });
    }
    if (!this.isEditNote && this.noteName.valid) {

      this.note.createdAt = new Date();
      this.note.createdBy = this.data.loggedUser.id;
      this.note.createdByName = this.data.loggedUser.name;

      this.collaborationService.createDocument(this.data.spaceID, this.data.appID, this.note, 'Note')
        .subscribe({
          next: (response: IFile) => {
            this.isEditNote = true;
            this.note = response;
            this.initialData = {
              noteName: this.note.name,
              content: this.control.value
            }
            this.newNoteCreated = true;           
            if (response && response.versions && response.versions.length)
              this.setCurrentViewingVersion(response.versions[0]);
            return;
          }, error: (err: any) => {
            this.dialogRef.close('error');
            return;
          }
        });
    }
  }

  handleAction(action: any) {
    switch (action) {
      case 'details':
        this.openNoteDetails();
        break;
      case 'openLocation':
        this.closeNote();
        break;
      case 'rename':
        this.renameNote();
        break;
      case 'subscribe':
        this.followUnfollow();
        break;
      case 'unsubscribe':
        this.followUnfollow();
        break;
    }
  }

  openNoteDetails() {
    this.matDialog.open(FileDetailsDialogComponent, {
      data: { ...this.note, user: { id: this.note.createdBy, name: this.note.createdByName, email: this.note.createdByName } },
      width: '90vw',
      disableClose: true
    }).afterClosed().subscribe({
      next: (value: any) => {
        if (value) {
          this.followUnfollow();
        }
      }
    })
  }

  renameNote() {
    this.matDialog.open(CreateFileDialogComponent, {
      data: {
        type: "Save",
        fileName: this.noteName.value,
        dialogTitle: 'Rename Note'
      },
      maxHeight: '90vh',
      width: '90vw',
      disableClose: true
    }).afterClosed().subscribe({
      next: (value: any) => {
        if (value) {
          this.showLoader = true;
          this.collaborationService.fileAction(
            {
              contentId: this.note.id,
              parentId: this.data.parentID ?? null,
              appId: this.note.appId,
              spaceId: this.note.spaceId,
              name: value.folderName,
              modifiedBy: this.data.loggedUser.id
            },
            'renameFile'
          ).subscribe({
            next: (response: any) => {
              this.noteUpdatedFromActions = true;
              this.note.name = value.folderName;
              this.noteName.patchValue(value.folderName);
              this.showLoader = false;
            }, error: (err: any) => {
              this.showLoader = false;
              this.collaborationService.displayErrorMessage(err, 'Error renaming note. Please try after some time.');
            }
          })
        }
      }
    })
  }

  followUnfollow() {
    this.collaborationService.likeOrFollow({
      entityTypeId: 17,
      entityId: this.note.id,
      userId: this.data.loggedUser.id,
      requestType: 'follow'
    }, 'follow').subscribe({
      next: (response: any) => {
        this.noteUpdatedFromActions = true;
        this.note.contentFollowed = !this.note.contentFollowed;
        this.initializeNoteActions();
      }, error: (err: any) => {
        this.collaborationService.displayErrorMessage(err, 'Network error. Please try after some time.');
      }
    })
  }

  initializeNoteActions() {
    if (this.isLoginUserIsCreatorOfNote) {
      this.isLoginUserIsCreatorOfNote = true;
      this.noteActionsList.push({
        name: "rename",
        displayName: "Rename",
        imgUrl: "textbox",
        menuItemClasses: "icon-mr-1",
      })
    }
    // if (this.note.contentFollowed) {
    //   this.noteActionsList[this.noteActionsList.length - 1] = this.unsubscribeAction;
    // }
  }

  ngOnDestroy() {
    this.control.setValue(undefined);
  }

  discardNote() {
    //should delete note in the files
    // const index = this.data.dataSource?.findIndex((file: any) => file.id === this.note.id);
    // if (index !== -1) {
    //   this.data.dataSource?.splice(index, 1);
    //   this.closeNote();
    // }
    // else {
    //   this.closeNote();
    // }
  }

  onDragOver(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedOver = true;
  }

  onDragLeave(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedOver = false;
  }

  onFileDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.draggedOver = false;
    const files = event.dataTransfer.files;
    this.onFileChange(files);
  }

  async onFileChange(files: any) {
    if (!this.attachmentsPayload?.files || !this.attachmentsPayload?.files?.length) {
      this.attachmentsPayload = {
        requestedBy: this.data.loggedUser.id,
        requestedAt: new Date().toISOString(),
        files: []
      };
    }
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      let [fileName, fileType] = file.name.split('.');
      const fileContent = await this.collaborationService.getBase64File(file);
      const newFile = {
        name: file.name,
        fileContent,
        appId: this.data.fileAppID,
        spaceId: this.data.fileSpaceID,
        parentId: this.data.parentID,
        fileExtension: fileType,
        kind: this.data.extensionMapper[fileType],
        properties: JSON.stringify({ Description: "" }),
        createdAt: new Date().toISOString(),
        modifiedAt: new Date().toISOString(),
        createdBy: this.data.loggedUser.id,
        modifiedBy: this.data.loggedUser.id,
        blobName: file.name,
        blobMediaType: file.type,
        blobSize: file.size,
        blobCreatedAt: new Date().toISOString(),
        blobCreatedBy: this.data.loggedUser.id
      };
      this.attachmentsPayload.files = [...this.attachmentsPayload.files, newFile];
    }
  }

  deleteAttachedFile(file: any) {
    const fileIndex = this.note.attachments?.findIndex((item: any) => item.name === file.name && item.type === file.type);
    if (fileIndex === undefined) return;
    this.note.attachments?.splice(fileIndex, 1);
    this.snackBar.open(
      'Attachment was trashed.',
      'X',
      {
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ["snackbar", "success", "snackbar-top"]
      });
  }

  revertVersion(version: any) {
    let properties = JSON.parse(version.properties);
    this.control.patchValue(properties.Body);
    this.control.markAsDirty();
    this.createNote();
  }

  removeVersion(version: any) {
    this.showLoader = true;
    this.collaborationService.deleteVersion({
      id: version.id,
      createdAt: version.createdAt
    }).subscribe({
      next: (response: any) => {
        this.note.versions = this.note.versions.filter(row => row.contentCreatedAt !== version.contentCreatedAt);
        let properties = JSON.parse(this.note.versions[0].properties);
        this.control.patchValue(properties.Body);
        this.showLoader = false;
      },
      error: (err: any) => {
        this.showLoader = false;
        this.collaborationService.displayErrorMessage(err, 'Error removing the version. Please try again.');
      }
    })
  }

  async openUserDetailsDialog(data: any) {
    this.matDialog.open(UserDetailsDialogComponent, {
      data: {
        ...data,
        //profilePictureUrl: await lastValueFrom(this.collaborationService.getUserProfilePicture(data.createdByEmail)) },
        profilePictureUrl: assetUrl('images/user.svg')
      },
      autoFocus: false
    });
  }
}
